//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueSignature from './vueSignature'
import { rotateBase64Img } from '@/tools'
import { isIphonex } from '@runwork/runwork-help'
export default {
  props: {
    questionsList: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: () => '',
    },
  },
  components: { vueSignature },
  data() {
    return {
      isOrient: '0',
      width: '300',
      height: '700',
      hasLine: false,
      disabled: false,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: '#f7f8fa',
      },
    }
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
  },
  methods: {
    resetUrl(val) {
      let _this = this
      if (val) {
        rotateBase64Img(val, 90, (data) => {
          _this.$refs.signature1.fromDataURL(data)
          _this.hasLine = true
        })
      }
    },
    submit() {
      let _this = this
      let jpeg = _this.$refs.signature1.save('image/jpeg')
      _this.chooseItem(jpeg)
      // rotateBase64Img(jpeg, 270, (data) => {
      //   _this.$nextTick(() => {
      //     _this.chooseItem(data)
      //   })
      // })
    },
    clear() {
      let _this = this
      _this.hasLine = false
      _this.$refs.signature1.clear()
    },
    chooseItem(item) {
      this.$emit('onchoose', item)
    },
    close() {
      this.clear()
      this.$emit('onclose')
    },
    cancel() {
      this.clear()
      this.$emit('popup-close')
    },
  },
  mounted() {
    let _this = this
    // //判断手机横竖屏状态：
    // const orient = function () {
    //   if (window.orientation == 180 || window.orientation == 0) {
    //     _this.isOrient = '0'
    //   }
    //   if (window.orientation == 90) {
    //     _this.isOrient = '1'
    //   }
    //   if (window.orientation == -90) {
    //     _this.isOrient = '2'
    //   }
    // }
    // window.addEventListener(
    //   'onorientationchange' in window ? 'orientationchange' : 'resize',
    //   () => {
    //     isReady = true
    //     orient()
    //   },
    //   false
    // )
    _this.hasLine = false
    _this.width = `${_this.$refs.signatureContent.offsetWidth}`
    _this.height = `${_this.$refs.signatureContent.offsetHeight}`
    // orient()
    _this.$refs.signature1.$el.firstChild.addEventListener('touchstart', () => {
      _this.hasLine = true
    })
    _this.$refs.signature1.$el.firstChild.addEventListener('click', () => {
      _this.hasLine = true
    })
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     _this.resetUrl(_this.url)
    //   })
    // })
  },
}
